"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStatus = void 0;

var _history = require("../../utils/history");

var _reactRouterRedux = require("react-router-redux");

var _appstatus = require("../actions/appstatus");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// actions

/* ========== ~~~~~~~~~~ APP STATUS : REDUCER ~~~~~~~~~~ ========== */


var defaultState = {
  currentApp: null,
  currentPage: _history.history.location.pathname.replace('/', ''),
  // this should match route in app.js
  previousPage: null,
  clientSites: {},
  messages: {},
  editMode: false
}; // REDUCER

var appStatus = function appStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var newState = JSON.parse(JSON.stringify(state));

  switch (action.type) {
    case _appstatus.UPDATE_CURRENT_APP:
      newState.currentApp = action.name;
      return newState;

    case _appstatus.UPDATE_PAGE_DETAILS:
      newState.previousPage = newState.currentPage;
      newState.currentPage = action.location;
      return newState;

    case _appstatus.MOVE_TO_PAGE:
      newState.previousPage = newState.currentPage;
      newState.currentPage = action.location;
      (0, _reactRouterRedux.push)("/".concat(action.location === undefined ? '' : action.location));
      return newState;

    case _appstatus.SET_EDIT_MODE:
      newState.editMode = action.editState;
      return newState;

    case 'CLEAR_ALL_STATES':
      return defaultState;

    default:
      return newState;
  }
};

exports.appStatus = appStatus;